import React, { useState, useEffect } from 'react';
import {
  Box,
  Modal,
  InputBase,
  IconButton,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';
import { tokens } from '../../theme'; // Ajustá la ruta si es necesario
import { getUserView } from '../../services/user.services';

const ModalUserTejido = ({ open, onClose, onSelectUsuario }) => {
  const [usuarios, setUsuarios] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "firstname", headerName: "Nombre", flex: 1 },
    { field: "lastname", headerName: "Apellido", flex: 1 },
  ];

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await getUserView();
        const soloTejido = response.filter(
          (u) => u.grupo?.toLowerCase() === "tejido"
        );
        setUsuarios(soloTejido);
        setFilteredData(soloTejido);
      } catch (error) {
        console.error('Error al obtener datos del backend:', error);
      }
    };

    fetchUsers();
  }, []);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
    const value = event.target.value.toLowerCase();
    const filtered = usuarios.filter(
      (u) =>
        u.firstname.toLowerCase().includes(value) ||
        u.lastname.toLowerCase().includes(value) ||
        String(u.id).includes(value)
    );
    setFilteredData(filtered);
  };

  const handleRowDoubleClick = (params) => {
    onSelectUsuario(params.row);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-horario-title"
      aria-describedby="modal-horario-description"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.primary[600],
          paddingLeft: "10px",
          paddingTop: "5px",
          paddingRight: "10px",
          paddingBottom: "10px!important",
          zIndex: 1500,
        }}
      >
        <Box m="0px">
          <Box display="flex" justifyContent="space-between" p={2} >
            <h1 id="owner-modal-title">Seleccionar Funcionario</h1>
            <Box
              display="flex"
              backgroundColor={colors.primary[400]}
              borderRadius="3px"
              height={"40%"}
              width={"40%"}
              marginTop={"3%"}
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                placeholder="Buscar"
                value={searchValue}
                onChange={handleSearchChange}
              />
              <IconButton type="button" sx={{ p: 1 }}>
                <SearchIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            m="10px 0"
            height="70vh"
            width="80vh"
            sx={{
              "& .MuiDataGrid-root": { border: "none" },
              "& .MuiDataGrid-cell": { borderBottom: "none" },
              "& .name-column--cell": { color: colors.greenAccent[300] },
              "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[900], borderBottom: "none" },
              "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
              "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[900] },
              "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
            }}
          >
            <DataGrid
              checkboxSelection
              rows={filteredData}
              columns={columns}
              onRowDoubleClick={handleRowDoubleClick}
              getRowId={(row) => row.id}
            />
          </Box>
        </Box>
        {/* Botón seleccionar si quieres habilitarlo */}
        {/* <Button onClick={handleRowDoubleClick} color="secondary" variant="contained" style={{ marginTop: "10px" }}>
          Seleccionar
        </Button> */}
      </Box>
    </Modal>
  );
};

export default ModalUserTejido;
